import React, { useState, useEffect } from 'react';

interface Brand {
  id?: number;
  brandName: string;
}

interface BrandFormProps {
  brand: Brand | null;
  onSubmit: (brand: Brand) => void;
  onCancel: () => void;
}

const BrandForm: React.FC<BrandFormProps> = ({ brand, onSubmit, onCancel }) => {
  const [brandName, setBrandName] = useState<string>('');
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (brand) {
      setBrandName(brand.brandName);
    } else {
      setBrandName('');
    }
  }, [brand]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    // Validate
    if (!brandName.trim()) {
      setError('Brand name is required');
      return;
    }
    
    // Clear any previous errors
    setError(null);
    
    // Submit the form
    onSubmit({
      ...(brand ? { id: brand.id } : {}),
      brandName: brandName.trim()
    });
  };

  return (
    <div className="form-container">
      <h2>{brand ? 'Edit Brand' : 'Add New Brand'}</h2>
      
      {error && <div className="error-message">{error}</div>}
      
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="brandName">Brand Name</label>
          <input
            type="text"
            id="brandName"
            value={brandName}
            onChange={(e) => setBrandName(e.target.value)}
            placeholder="Enter brand name"
            autoFocus
          />
        </div>
        
        <div className="form-actions">
          <button 
            type="button" 
            className="secondary-button" 
            onClick={onCancel}
          >
            Cancel
          </button>
          <button 
            type="submit" 
            className="primary-button"
          >
            {brand ? 'Update' : 'Create'} Brand
          </button>
        </div>
      </form>
    </div>
  );
};

export default BrandForm; 